import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import ActionCancelButton from "../../components/ActionCancelButton";
import InitiateInvokeModal from "../LoanAction/Invoke/InitiateInvokeModal";
import CancelInvokeModal from "../LoanAction/Invoke/CancelInvokeModal";
import LoanDetailsCard from "../../components/LoanDetailsCard";
import OrderLoanTable from "./OrderLoanTable";
import { IoCopyOutline } from "react-icons/io5";
import axios from "axios";
import ActionBlueButtonOrders from "./ActionBlueButtonOrders";
import InitiateRevokeModal from "../LoanAction/Revoke/InitiateRevokeModal";
import CancelRevokeModal from "../LoanAction/Revoke/CancelRevokeModal";
import { FaCheck } from "react-icons/fa6";
import ImageLoading from "../../components/ImageLoading";
import { FiDownload } from "react-icons/fi";
import OdActivity from "../../components/OdActivity";
import InterestCalculation from "../../components/InterestCalculation";
import SecurityDetails from "../../components/SecurityDetails";
import LoanDetailsCardOd from "../../components/LoanDetailsCardOd";
import NoDataFound from "../../components/NoDataFound";
import OrderTimeline from "./Sections/OrderTimeline";

function SingleOrderView({ closeOrder, orderId, userId, switchOd }) {
  const token = localStorage.getItem("token");
  const [initiateModal, setInitiateModal] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [reRender, setReRender] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [data, setData] = useState({});
  const [state, setState] = useState("");
  const [showRevokeModal, setShowRevokeModal] = useState(false);
  const [showCancelRevokeModal, setShowCancelRevokeModal] = useState(false);
  const [orderArray, setOrderArray] = useState([]);
  const [copied, setCopied] = useState(false);
  const [noData, setNoData] = useState(false);

  const [OdOptions, setOdOptions] = useState("Loan Details");
  const CopyButton = () => {
    return <IoCopyOutline style={{ width: "18px", height: "18px" }} />;
  };
  const CheckIcon = () => {
    return <FaCheck style={{ width: "18px", height: "18px" }} />;
  };
  const fetchSingleOrder = async () => {
    setImageLoading(true);
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    let url;

    url = `${process.env.REACT_APP_URL}/lender/v1/orders/${orderId}?id=${userId}`;

    try {
      const res = await axios.request(url, options);
      if (switchOd) {
        if (res?.data.error) {
          setNoData(true);
        } else {
          setData(res?.data?.data);
          setNoData(false);
        }
        setImageLoading(false);
      } else {
        setOrderArray(res.data.order_detail.order_uuid);
        setData(res.data);
        setImageLoading(false);
        setNoData(false);
      }
      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      setNoData(true);
      setImageLoading(false);
    } finally {
    }
  };

  const handleCopy = (link) => {
    if (!document.hasFocus()) {
      return;
    }
    if (link === undefined || link === null) {
      return;
    }

    navigator.clipboard.writeText(link);
    setCopied(true);
    let timer = setTimeout(() => {
      setCopied(false);
      clearTimeout(timer);
    }, 3000);
  };

  const setOrderColor = (status) => {
    const failedStatuses = [
      "Loan Not Disbursed",
      "Invoke Failed",
      "Revoke Failed",
      "Market Invoke",
      "Overdue EMI",
      "90 DPD",
      "failed",
      "Failed",
      "Margin Call",
    ];
    const initiatedStatuses = ["Revocation Initiated", "Invocation Initiated"];

    if (failedStatuses.includes(status)) {
      return "bg-[#d30d00]";
    }
    if (initiatedStatuses.includes(status)) {
      return "bg-[#d3bf05]";
    }
    return "bg-[#0ba300]";
  };

  useEffect(() => {
    fetchSingleOrder();
  }, [reRender]);

  const handleExcelDownload = async () => {
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/orders/${orderId}/od_interest_reconcilation_report`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res.data.download_url.status) {
        const url = res.data.download_url.data;
        handleDownloadFile(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <>
      {imageLoading && (
        <div className="mt-4 w-full h-[calc(100vh-180px)] flex justify-center items-center bg-white rounded-lg p-4">
          <ImageLoading />
        </div>
      )}
      {noData && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <NoDataFound />
        </div>
      )}
      {!imageLoading && !noData && (
        <div className="mt-4 w-full h-fit bg-white rounded-lg px-4 pb-4 relative">
          <div className="sticky bg-white top-0 left-0 py-4 border-b border-[#e2ecff]">
            <div className="flex items-center justify-between">
              <button
                className="text-[#00394d] text-sm font-bold flex items-center"
                onClick={() => closeOrder(false)}
              >
                <span className=" mr-2">
                  <FaArrowLeft style={{ width: "18px", height: "18px" }} />
                </span>
                Back
              </button>
              <div className={`w-full flex justify-between ml-4`}>
                {!switchOd ? (
                  <div className="flex items-center">
                    <p className=" text-base font-semibold mr-4">
                      {data?.order_detail?.order_reference_no || "---"}
                    </p>
                    <div className=" border rounded-xl mr-3 px-2 py-1 border-black inline-flex items-center font-medium text-xs ">
                      <span
                        className={` w-[10px] h-[10px] rounded-full ${setOrderColor(
                          data?.order_detail?.loan_details?.action_status
                            ?.status || "--"
                        )} block mr-[10px]`}
                      ></span>{" "}
                      {data?.order_detail?.loan_details?.action_status.status ||
                        "--"}{" "}
                    </div>
                    <p className="text-[12px] text-[#8b8b8b] font-medium">
                      on{" "}
                      {data?.order_detail?.loan_details?.action_status.date ||
                        "--"}{" "}
                    </p>
                  </div>
                ) : (
                  <div className="flex items-center ">
                    <p className=" text-base font-semibold mr-4">
                      {data?.overdraft_detail?.order_reference_no || "---"}
                    </p>
                    <div className=" border rounded-xl mr-3 px-2 py-1 border-black inline-flex items-center font-medium text-xs ">
                      <span
                        className={` w-[10px] h-[10px] rounded-full ${setOrderColor(
                          data?.overdraft_detail?.action_status?.status || "--"
                        )} block mr-[10px]`}
                      ></span>{" "}
                      {data?.overdraft_detail?.action_status.status || "--"}{" "}
                    </div>
                    <p className="text-[12px] text-[#8b8b8b] font-medium">
                      on {data?.overdraft_detail?.action_status.date || "--"}{" "}
                    </p>
                  </div>
                )}
                {switchOd ? (
                  <button
                    className="text-sm font-semibold py-[6px] px-4 flex justify-center items-center bg-[#00394d] text-white rounded"
                    onClick={() => {
                      handleExcelDownload();
                    }}
                  >
                    <span className=" mr-2">
                      <FiDownload />
                    </span>
                    Download
                  </button>
                ) : (
                  <div className=" flex items-center">
                    {data.order_detail?.loan_details?.action_status?.buttons?.includes(
                      "prepayment_link"
                    ) &&
                      !copied && (
                        <ActionCancelButton
                          setInvokeModal={setCancelModal}
                          text={"Prepayment Link"}
                          style={`mr-2`}
                          onClick={() => {
                            handleCopy(data.order_detail?.prepayment_link);
                          }}
                          Icon={CopyButton}
                        />
                      )}
                    {copied && (
                      <ActionCancelButton
                        disabled={true}
                        text={"Link Copied"}
                        style={` mr-2 border-[#0ba300] !text-[#0ba300] bg-[white]`}
                        Icon={CheckIcon}
                      />
                    )}
                    {data.order_detail?.loan_details?.action_status?.buttons?.includes(
                      "cancel_invoke"
                    ) && (
                      <ActionCancelButton
                        setInvokeModal={setCancelModal}
                        text={"Cancel Invoke"}
                        style={`mr-4`}
                        onClick={() => setCancelModal(true)}
                      />
                    )}
                    {data.order_detail?.loan_details?.action_status?.buttons?.includes(
                      "cancel_revoke"
                    ) && (
                      <ActionCancelButton
                        setInvokeModal={setShowCancelRevokeModal}
                        text={"Cancel Revoke"}
                        style={`mr-4`}
                        onClick={() => setShowCancelRevokeModal(true)}
                      />
                    )}
                    {data.order_detail?.loan_details?.action_status?.buttons?.includes(
                      "invoke_now"
                    ) && (
                      <ActionBlueButtonOrders
                        text={"Invoke Now"}
                        disabled={false}
                        onClick={() => {
                          setState("initiatedInvocation");
                          setInitiateModal(true);
                        }}
                      />
                    )}

                    {data.order_detail?.loan_details?.action_status?.buttons?.includes(
                      "revoke_now"
                    ) && (
                      <ActionBlueButtonOrders
                        text={"Revoke Now"}
                        onClick={() => {
                          setState("initiatedInvocation");
                          setShowRevokeModal(true);
                        }}
                      />
                    )}
                    {data.order_detail?.loan_details?.action_status?.buttons?.includes(
                      "initiate_invoke"
                    ) && (
                      <ActionBlueButtonOrders
                        text={"Initiate Invoke"}
                        onClick={() => {
                          setInitiateModal(true);
                        }}
                      />
                    )}
                    {data.order_detail?.loan_details?.action_status?.buttons?.includes(
                      "initiate_revoke"
                    ) && (
                      <ActionBlueButtonOrders
                        text={"Initiate Revoke"}
                        onClick={() => {
                          setShowRevokeModal(true);
                        }}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          {switchOd ? (
            <>
              <div className="flex justify-between items-center mt-4 rounded-lg w-fit bg-[#F4F4F4] py-0.5 px-0.5 h-[32px]">
                <button
                  className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                    OdOptions === "Loan Details" ? "bg-white rounded" : ""
                  }`}
                  onClick={() => setOdOptions("Loan Details")}
                >
                  Loan Details
                </button>
                <button
                  className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                    OdOptions === "OD Activity" ? "bg-white rounded" : ""
                  }`}
                  onClick={() => setOdOptions("OD Activity")}
                >
                  OD Activity
                </button>
                <button
                  className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                    OdOptions === "Interest Calculation"
                      ? "bg-white rounded"
                      : ""
                  }`}
                  onClick={() => setOdOptions("Interest Calculation")}
                >
                  Interest Calculation
                </button>
                <button
                  className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                    OdOptions === "Security Details" ? "bg-white rounded" : ""
                  }`}
                  onClick={() => setOdOptions("Security Details")}
                >
                  Security Details
                </button>
                <button
                  className={`text-xs font-bold m-0.5 px-4 py-1 text-[#262626] ${
                    OdOptions === "Order Timeline" ? "bg-white rounded" : ""
                  }`}
                  onClick={() => setOdOptions("Order Timeline")}
                >
                  Order Timeline
                </button>
              </div>
              {OdOptions === "Loan Details" ? (
                <LoanDetailsCardOd
                  data={data.overdraft_detail !== null && data.overdraft_detail}
                  orderId={orderId}
                />
              ) : OdOptions === "OD Activity" ? (
                <OdActivity
                  data={
                    data.od_transaction_activity !== null &&
                    data.od_transaction_activity
                  }
                />
              ) : OdOptions === "Interest Calculation" ? (
                <InterestCalculation
                  data={
                    data.interest_calculator !== null &&
                    data.interest_calculator
                  }
                />
              ) : OdOptions === "Order Timeline" ? (
                <OrderTimeline id={userId} orderId={orderId} />
              ) : (
                <SecurityDetails
                  data={data.security_detail !== null && data.security_detail}
                />
              )}
            </>
          ) : (
            <div className=" ">
              <LoanDetailsCard
                data={data.order_detail !== null && data.order_detail}
              />
              <OrderLoanTable
                orderItems={data.order_detail?.order_items}
                totalPercentage={
                  data.order_detail
                    ?.total_current_pledged_asset_value_percentage
                }
                totalPledgedValue={
                  data.order_detail?.total_current_pledged_asset_value
                }
                initialPledgedValue={
                  data.order_detail?.pledge_details.initial_pledged_value
                }
              />
            </div>
          )}
        </div>
      )}

      {initiateModal && (
        <InitiateInvokeModal
          cancelFunction={setInitiateModal}
          selectedItems={orderArray}
          invocationState={state}
          setReRender={setReRender}
          reRender={reRender}
          setReadOnly={setReadOnly}
        />
      )}
      {cancelModal && (
        <CancelInvokeModal
          cancelFunction={setCancelModal}
          selectedItems={orderArray}
          setReRender={setReRender}
          reRender={reRender}
        />
      )}
      {showRevokeModal && (
        <InitiateRevokeModal
          cancelFunction={setShowRevokeModal}
          selectedItems={orderArray}
          invocationState={state}
          reRender={reRender}
          setReRender={setReRender}
          setReadOnly={setReadOnly}
        />
      )}
      {showCancelRevokeModal && (
        <CancelRevokeModal
          cancelFunction={setShowCancelRevokeModal}
          selectedItems={orderArray}
          setReRender={setReRender}
          reRender={reRender}
        />
      )}
    </>
  );
}

export default SingleOrderView;
